module.exports = __webpack_public_path__ + "static/img/collectionImg.8ea19a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/collectionImg.png
// module id = 8bMV
// module chunks = 52